export default {
  'Every Day': 'Every Day',
  'Nursing Bra': 'Nursing Bra',
  'Sports Bra': 'Sports Bra',
  'Sexy': 'Sexy',
  'Swimsuit': 'Swimsuits',
  'Strapless': 'Strapless',
  'Panty': 'Panty',
}
